export default "__VITE_ASSET__9ZHqML3V__"